module.exports = __webpack_public_path__ + "img/pdf-download.3b8bc6dd.svg";